module.exports = __webpack_public_path__ + "img/6.5534baac.png";